import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { lightOrange } from 'styles/vars';

const SmartDiscardIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 18 18">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.405 3.9225L14.3625 2.6625C14.16 2.4075 13.8525 2.25 13.5 2.25H4.5C4.1475 2.25 3.84 2.4075 3.63 2.6625L2.595 3.9225C2.3775 4.1775 2.25 4.515 2.25 4.875V14.25C2.25 15.075 2.925 15.75 3.75 15.75H14.25C15.075 15.75 15.75 15.075 15.75 14.25V4.875C15.75 4.515 15.6225 4.1775 15.405 3.9225ZM4.68 3.75H13.32L13.9275 4.4775H4.08L4.68 3.75ZM3.75 14.25V6H14.25V14.25H3.75ZM10.0875 7.5H7.9125V9.75H6L9 12.75L12 9.75H10.0875V7.5Z"
        fill={lightOrange}
      />
    </SvgIcon>
  );
};

export default SmartDiscardIcon;
